// Score → color band, per GEO Page Audit Report design tokens.
export function scoreColor(score) {
  if (score >= 80) return "#16A34A";
  if (score >= 50) return "#F59E0B";
  return "#DC2626";
}
